export * from './PromoSkeleton';
